var map = {
	"./IMG_1_VIDEO.mp4": 97691,
	"./IMG_24_VIDEO.mp4": 84474,
	"./IMG_29_VIDEO.mp4": 71203,
	"./IMG_8_VIDEO.mp4": 75382
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66352;